import "./telConfirmModal.scss";

let activeModal = null;

// Interpolations land in innerHTML and can carry user-authored strings.
const esc = value =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const getModalHTML = (title, message, valueLabel, currentValue, confirmLabel) => `
  <div class="tel-confirm-modal">
    <div class="tel-confirm-modal__title">${esc(title)}</div>
    <div class="tel-confirm-modal__message">${esc(message)}</div>
    ${currentValue ? `
      <div class="tel-confirm-modal__value">
        <span class="tel-confirm-modal__value-label">${esc(valueLabel)}</span>
        <span class="tel-confirm-modal__value-text">${esc(currentValue)}</span>
      </div>
    ` : ""}
    <div class="tel-confirm-modal__actions">
      <button class="tel-confirm-modal__btn tel-confirm-modal__btn--cancel">Cancel</button>
      <button class="tel-confirm-modal__btn tel-confirm-modal__btn--confirm">${esc(confirmLabel)}</button>
    </div>
  </div>
`;

export function showTelConfirmModal(message, currentValue) {
  return showConfirmModal({ title: "Invalid phone link", message, value: currentValue });
}

export function showConfirmModal({
  title,
  message,
  value,
  valueLabel = "Incorrect value:",
  confirmLabel = "Save anyway",
}) {
  if (activeModal) {
    activeModal.reject();
    activeModal = null;
  }

  return new Promise(resolve => {
    let onKeydown = null;

    const cleanup = () => {
      if (onKeydown) document.removeEventListener("keydown", onKeydown, true);
      if (overlay.parentElement) overlay.remove();
      activeModal = null;
    };

    const overlay = document.createElement("div");
    overlay.className = "tel-confirm-overlay";
    overlay.innerHTML = getModalHTML(title, message, valueLabel, value, confirmLabel);

    overlay.querySelector(".tel-confirm-modal__btn--cancel").onclick = () => { cleanup(); resolve(false); };
    overlay.querySelector(".tel-confirm-modal__btn--confirm").onclick = () => { cleanup(); resolve(true); };
    overlay.onclick = e => { if (e.target === overlay) { cleanup(); resolve(false); } };

    onKeydown = e => { if (e.key === "Escape") { cleanup(); resolve(false); } };
    document.addEventListener("keydown", onKeydown, true);

    document.body.appendChild(overlay);
    activeModal = { reject: () => { cleanup(); resolve(false); } };
    overlay.querySelector(".tel-confirm-modal__btn--confirm").focus();
  });
}
